<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 0.8s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes mc-01 {
    0% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #mc-01 {
    animation-name: mc-01;
  }
  @keyframes mc-02 {
    0% {
      opacity: 0;
    }
    50%,
    100% {
      opacity: 1;
    }
  }
  #mc-02 {
    animation-name: mc-02;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 581.9 302.9" height="100%" width="100%">>
<g class:paused={isPaused}>
  <g class="shapes" bind:this={rootElement}>
    <g id="mc-02">
      <path
        fill="var(--hair)"
        d="M582 77c-6 5-13 3-19 0-1-3 1-5 1-8 1-8-1-10-8-8h-5c-5-8-12-7-20-7-5-1-9-3-11-8s5-4 7-6c4-3 7-6 4-11-2-5-7-5-11-2l-14 5c-5 2-11-2-13-8 15-6 29-14 45-18 15-3 27 3 33 16 5 14 8 27 8 42 0 2 0 5 3 7Z"
      />
      <path
        fill="var(--shirt)"
        d="M476 120c-12-6-25-2-37-3-2 0-3-2-3-4s-1-3-3-2c-9 1-19 4-28 3-2-2-4-3-7-3-7 0-13 4-20 3a13 13 0 0 1-8-6l-11-19c0-2 0-4-2-4-8-2-14-10-23-12-2 0-5-2-6-5-7-12-19-20-30-29-7-5-14-10-23-9-2-4 2-4 4-5l18-3 12-6a14 14 0 0 1 6-3c32-7 64-14 98-13 22 1 42 6 62 12a19 19 0 0 1 11 8l5 5 3 25c2 13-2 25-5 37l-6 21c-1 4 0 11-7 12Z"
      />
      <path
        fill="var(--pants)"
        d="M275 30c9-1 16 4 23 9 11 9 23 17 30 29 1 3 4 5 6 5 9 2 15 10 23 12a500 500 0 0 0 13 23 13 13 0 0 0 8 6c-1 5 2 9 3 14 1 6 8 11 4 19-14 7-30 7-46 7-4 0-8-1-12 1l-7 1c-11 3-16-1-21-10-8-14-9-14-21-4-8 6-16 11-23 18-5 4-9 3-13 1l-21-12c5-4 3-6-1-9a222 222 0 0 1-34-27c0-4 3-5 5-6 14-11 29-21 41-34a16 16 0 0 0 4-5c7-19 20-32 39-38Z"
      />
      <path
        fill="var(--flesh)"
        d="M186 113a222 222 0 0 0 34 27c4 3 6 5 1 9-16 11-36 15-54 22a62 62 0 0 1-17 5 48 48 0 0 0-20 7c-17 10-35 17-53 23a53 53 0 0 0-27 19c-4 2-8 2-12-1-4-2-9-4-11-8s-1-9 3-11c3-2 5-4 5-8 13-2 23-10 34-17 13-8 25-19 39-26a106 106 0 0 1 25-9c19-4 34-15 47-28l6-4Z"
      />
      <path
        fill="var(--flesh)"
        d="M489 87c3-12 7-24 5-37l-3-25 2-1c2 6 8 10 13 8s10-3 14-5c4-3 9-3 11 2 3 5 0 8-4 11-2 2-8 1-7 6s6 7 11 8c8 0 15-1 20 7h5c7-2 9 0 8 8 0 3-2 5-1 8-12 5-26 5-35 15-3 3-6 4-9 1-1-1-2-3-3-2-7 5-15-2-22 0-3 0-3-2-5-4Z"
      />
      <path
        fill="var(--hair)"
        d="M35 197c0 4-2 6-5 8-4 3-5 7-3 11s7 6 11 8c4 3 8 3 12 1 2 1 6 1 2 4a16 16 0 0 0-5 8c-1 8-3 14 7 18 4 1 7 4 10 7 4 4 2 9-3 10-14 4-28 4-41-5-6-4-10-9-10-15-1-14-5-27-7-40-2-14 5-21 19-18l13 3ZM242 183c-6 6-13 10-9 21 2 6 8 10 15 7 3-1 6 0 8 1-1 4-6 6-8 11-2 8-3 15-1 23v4c1 6 4 14-3 17-6 3-11-4-15-8a38 38 0 0 1-7-10c-8-18-14-36-16-55a34 34 0 0 1 2-12c1-5 6-1 9-2 8-3 16 1 23 0 2 0 2 2 2 3Z"
      />
      <path
        fill="var(--flesh)"
        d="M454 289c9-1 19-3 28 2-10 0-19 2-28-2ZM334 164l2 3Z"
      />
      <path
        fill="var(--flesh)"
        d="M514 281c-4-4-7-8-13-8-7-1-14-3-21-2-2 0-5 0-5-2 1-8-4-4-7-4-4 1-7 1-7-4 2-11 2-22 2-34 0-25 7-49 6-75-1-2 0-4 1-6 2-9 6-17 6-26-12-6-25-2-37-3 1 19-1 38-3 56-1 17 1 33 3 49 1 6 0 9-7 7-14-2-17-6-12-20 6-20 9-40 10-61 1-12 3-24 3-37-9 1-19 4-28 3l1 26c-1 8-4 16-4 24v6l-2 9c-1-4-1-8-5-11a62 62 0 0 0-10-21c-14 7-30 7-46 7-4 0-8-1-12 2 1 4 3 7 7 9l2 2a9 9 0 0 1 3 2 9 9 0 0 0-3-2c2 5 1 7-4 7-8 0-15 0-22 5a477 477 0 0 1-63 4l-5 1c-6 5-13 10-9 20 2 6 8 10 15 7 3-1 6 0 8 1 5-3 9-4 14-3 17 0 32 4 48 7 14 2 30 0 44 5 11 3 20 1 29-3s9-4 10 5c1 16 8 22 23 19l11-1c5 0 7 3 7 8l2 29c-1 6 3 11 10 11 9-1 19-3 28 2 4 1 9 1 13 3h7c1-4 4-5 8-4 2 0 5 1 5-2 1-2 2-5-1-7ZM312 179a18 18 0 0 0 3 0 18 18 0 0 1-3 0Zm21-2a15 15 0 0 0-5-1 15 15 0 0 1 5 1 5 5 0 0 0 1 0 5 5 0 0 1-1 0Z"
      />
    </g>
    <g id="mc-01">
      <path
        fill="var(--shirt)"
        d="m298 44 26-11 4-1c11 4 21-2 32-4l14-3c1 0 3 0 3-3h62c6 5 13 4 19 6l16 4c5 1 10 2 13 7a13 13 0 0 0 11 5l1 6a386 386 0 0 0-5 59c-5 1-4 5-5 9l-3 23a8 8 0 0 1-3 6c-8-3-17 0-25-1-8 0-15 4-18-1-2-6-1-11-1-17 0-13 2-11-11-11h-1a98 98 0 0 0-40-1c-21 4-40 12-60 19-6 2-10 2-11-6l-2-10c-2-13-6-26-6-39a135 135 0 0 0-5-31c0-4-2-5-5-5Z"
      />
      <path
        fill="var(--hair)"
        d="M0 214c7-5 14-11 23-9l7-1c6 3 1 6-1 8-4 7-3 14 4 16s15 8 22 0h5l-4 10c-1 5 1 9 1 13 1 7 7 4 11 6l11 5c5 2 6 9 1 11-13 7-26 12-41 8-9-3-15-8-18-17a241 241 0 0 0-21-41Z"
      />
      <path
        fill="var(--pants)"
        d="M298 44c3 0 5 1 5 5a135 135 0 0 1 5 31c0 13 4 26 6 39l2 10c-16 18-38 26-60 33-2 1-5 2-4-1 0-7-5-5-9-6l-7-11c-6-11-15-20-20-32 2-5 5-10 10-13a432 432 0 0 0 42-39c9-9 18-14 30-16Z"
      />
      <path
        fill="var(--flesh)"
        d="M427 117h1c13 0 11-2 11 11 0 6-1 11 1 17a1855 1855 0 0 0-8 53c-1 3-1 8 1 12 1 3 5 4 8 4s4-1 4-4c-1-17 1-34 1-51 0-13-1-13 12-13 8 1 17-2 25 1l-3 10c-2 7-5 14-3 22 1 5 0 11-1 16-6 24-8 48-12 73-1 5 1 8 7 6 3-1 8-4 7 4-1 3 2 2 4 2 7-1 14 2 21 2 7-1 10 6 15 9v6c0 2-3 3-5 2-3 0-6-2-9 3-1 2-5 1-8 0-8-2-17-3-26-2a30 30 0 0 1-6-1c-15-2-18-4-18-19a388 388 0 0 0-1-43c0-4-1-5-5-5a58 58 0 0 1-11-2c-8-2-12-7-12-16-1-23 2-46 3-69 1-9 2-20 7-28Z"
      />
      <path
        fill="var(--hair)"
        d="m499 50-1-6c13-5 25-12 38-15 15-4 26 2 32 15 7 15 6 31 9 47 1 4-3 8-8 7a20 20 0 0 1-9-3 19 19 0 0 0 2-11c0-3-3-6-5-5-6 4-9 0-13-3-2-3-5-2-8-2-5 0-10-1-14-4-2-3-4-6 1-8a13 13 0 0 0 5-3c3-3 5-6 2-10-3-3-6-4-10-1s-9 3-13 5c-3 2-6 0-8-3Z"
      />
      <path
        fill="var(--flesh)"
        d="M499 50c2 3 5 5 8 3 4-2 9-2 13-5s7-2 10 1c3 4 1 7-2 10a13 13 0 0 1-5 3c-5 2-3 5-1 8 4 3 9 4 14 4 3 0 6-1 8 1 4 4 7 8 13 4 2-1 5 2 5 5a19 19 0 0 1-2 11c-8 3-14 7-23 8-4 0-6 4-8 6-3 3-6 3-10 2-6-2-13 0-20-2l-5-1a385 385 0 0 1 5-58Z"
      />
      <path
        fill="var(--hair)"
        d="M79 211h1c6-2 13-5 21-6-3 7 0 10 6 12a24 24 0 0 1 5 3c5 3 4 9-1 11a42 42 0 0 1-22 3c-6 0-9-3-11-9l-3-9c0-3 3-3 4-5ZM94 165c-3 6-8 10-14 14l-13 8h-2c-5-14-3-17 12-20 4-1 9-1 13-4 2-1 3-1 4 2Z"
      />
      <path
        fill="var(--flesh)"
        d="M236 144c-6-11-15-20-20-32a68 68 0 0 1-46 17 43 43 0 0 0-27 11 1 1 0 0 0-1 1l-4 1c-11 10-26 12-37 21l-7 2c-3 6-8 10-14 14l-13 8h-2c-11 8-22 15-35 17 6 3 1 6-1 8-4 7-3 14 5 16 6 2 14 8 21 0h5c3-7 8-11 15-12 0-3 3-3 4-5h1c7-2 13-5 21-6l9-3c11-4 22-7 30-14a1 1 0 0 0 1-1c14-5 28-4 42-8 13-4 27-8 40-15 7-1 14-4 20-9l-7-11Z"
      />
    </g>
  </g>
  </g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>